import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { fetchMonthlyRevenueReport } from "../../../state/reducers/MonthlyRevenueSlice";
import { Bar } from "react-chartjs-2";
import "chart.js/auto";

const MonthlyRevenueChart = () => {
  const dispatch = useDispatch();
  const { data, status, error } = useSelector((state) => state.monthlyRevenue);

  const [year, setYear] = useState(new Date().getFullYear()); // Default to current year
  const [reportType, setReportType] = useState("Analytics"); // Default to Analytics view
  const [generateClicked, setGenerateClicked] = useState(false);
  useEffect(() => {
    dispatch(fetchMonthlyRevenueReport(year)); // Fetch monthly revenue for the selected year
  }, [dispatch, year]);

  // Prepare chart data
  const getChartData = () => {
    if (status === "succeeded" && data.length > 0) {
      const labels = data.map((item) => item.month);
      const revenues = data.map((item) => item.total_revenue);

      return {
        labels,
        datasets: [
          {
            label: `Monthly Revenue (${year})`,
            data: revenues,
            backgroundColor: "#1e40af", // Dark Blue color
            borderColor: "#00008B",
            borderWidth: 1,
          },
        ],
      };
    }

    // Fallback data if no API data is available
    return {
      labels: [],
      datasets: [
        {
          label: "No Data Available",
          data: [],
        },
      ],
    };
  };

  const renderList = () => {
    if (generateClicked && status === "succeeded" && data) {
      return (
        <div className="bg-white p-6 rounded-lg shadow-lg">
          <h3 className="text-xl font-semibold mb-4">Revenue Data</h3>
          <table className="min-w-full">
            <thead>
              <tr>
                <th className="px-4 py-2 text-left">Month</th>
                <th className="px-4 py-2 text-left">Revenue</th>
              </tr>
            </thead>
            <tbody>
              {data.map((item, index) => (
                <tr key={index}>
                  <td className="px-4 py-2">{item.month}</td>
                  <td className="px-4 py-2">{item.total_revenue}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      );
    }

    return <div className="text-center text-gray-500">No data available</div>;
  };
  const handleGenerate = () => {
    setGenerateClicked(true); // Set flag to true when Generate is clicked
  };
  const chartData = getChartData();

  return (
    <div className="bg-white p-6 rounded-md shadow-md">
      <div className="flex justify-between items-center mb-4">
        <h1 className="text-xl font-bold">Monthly Revenue Report</h1>
        <div className="flex gap-4">
          <input
            type="number"
            value={year}
            onChange={(e) => setYear(e.target.value)}
            className="border rounded-md px-4 py-2"
            placeholder="Enter Year"
          />
          <button
            onClick={() => dispatch(fetchMonthlyRevenueReport(year))}
            className="bg-blue-500 text-white px-4 py-2 rounded-md hover:bg-blue-600"
          >
            Fetch Data
          </button>
        </div>
      </div>
      <div className="flex gap-4 mb-6">
        <div className="flex gap-4">
          <select
            className="px-4 py-2 rounded-md"
            value={reportType}
            onChange={(e) => setReportType(e.target.value)}
          >
            <option value="Analytics">Analytics</option>
            <option value="List">List</option>
          </select>
        </div>

        <button
          onClick={handleGenerate}
          className="bg-blue-500 text-white px-4 py-2 rounded"
        >
          Generate
        </button>
      </div>
      {status === "loading" && <p className="text-gray-500">Loading...</p>}
      {status === "failed" && <p className="text-red-500">{error}</p>}
      {/* {chartData && chartData.labels.length > 0 && (
        <div>
          <Bar
            data={chartData}
            options={{
              responsive: true,
              plugins: {
                legend: {
                  display: true,
                  position: "top",
                },
              },
              scales: {
                y: {
                  beginAtZero: true,
                },
              },
            }}
          />
        </div>
      )} */}

      {reportType === "Analytics" ? (
        <div>
          <Bar
            data={chartData}
            options={{
              responsive: true,
              plugins: {
                legend: {
                  display: true,
                  position: "top",
                },
              },
              scales: {
                y: {
                  beginAtZero: true,
                },
              },
            }}
          />
        </div>
      ) : (
        renderList() // Show table when report type is 'List'
      )}
    </div>
  );
};

export default MonthlyRevenueChart;
